import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Button, Row, Col, Space, Form } from "antd";
import { useTranslation } from "react-i18next";
import BeleavePages from "../pages/BeleavePages";
import AllBesmartPages from "../pages/AllBesmartPages";
import LoginDevicesPages from "../pages/LoginDevices";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import FormAntd from "components/form/FormProvide/FormAntd";

const { Sider, Content } = Layout;
function Bestamp({
  initialValues = {},
  editConfigBesmart = () => { }
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [selectedKey, setSelectedKey] = useState("beSTAMP");

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  const onFinish = (values) => {
    editConfigBesmart(values);
  };

  const menuItems = [
    { key: "beSTAMP", label: t("configBesmart.be_Stamp") },
    { key: "beLEAVE", label: t("configBesmart.be_Leave") },
    { key: "allBESMART", label: t("configBesmart.all_Besmart") },
    { key: "LoginDevices", label: t("configBesmart.login_Devices") },
  ];

  const pageMapping = {
    beLEAVE: <BeleavePages />,
    allBESMART: <AllBesmartPages />,
    LoginDevices: <LoginDevicesPages />,
    beSTAMP: (
      <FormAntd form={form}
        initialValues={initialValues}
        onFinish={onFinish}>
        <Row justify="space-between" align="middle">
          <Col>
            <h2 style={{ color: "#313131", fontWeight: 600 }}>
              {t("configBesmart.be_Stamp")}
            </h2>
            <span style={{ color: "#667085" }}>
              {t("configBesmart.management_Checkin_CheckOut")}
            </span>
          </Col>

          <FormSwitch name="menucodeBestamp" />
        </Row>
        <div style={{ marginTop: 24 }}></div>
        <Card
          style={{
            border: "1px solid #EAECF0",
            borderRadius: 10,
            background: "#ffffff",
          }}
        >
          <div style={{ padding: 18, position: "relative" }}>
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.gps")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.checkin_Out_Gps")}
            </div>
            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchgps" />
            </div>
          </div>

          <div style={{ padding: 18, position: "relative" }}>
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.wifi")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.checkin_Out_Wifi")}
            </div>
            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchwifi" />
            </div>
          </div>

          <div style={{ padding: 18, position: "relative" }}>
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.selfie")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.checkin_Out_Selfie")}
            </div>
            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchselfie" />
            </div>
          </div>

          <div style={{ padding: 18, position: "relative" }}>
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.scan_Qrcode")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.checkin_Out_QRcode")}
            </div>
            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchqrcode" />
            </div>
          </div>
        </Card>

        <Row justify="end" style={{ marginTop: 40 }}>
          <Space size={12}>
            <Button type="default" size="large" style={{ borderRadius: 8 }}>
              {t("common.cancel").toUpperCase()}
            </Button>

            <Button
              type="primary"
              size="large"
              htmlType="submit"
              style={{
                borderRadius: 8,
                backgroundColor: "var(--button-color)",
              }}
            >
              {t("confirm").toUpperCase()}
            </Button>
          </Space>
        </Row>
      </FormAntd>
    ),
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={220}
        style={{
          background: "#ffffff",
          borderRight: "1px solid #eef1f4",
          paddingTop: 24,
        }}
      >
        <Menu
          selectedKeys={[selectedKey]}
          onClick={(item) => setSelectedKey(item.key)}
          items={menuItems}
        />
      </Sider>

      <Layout>
        <Content style={{ padding: 40 }}>{pageMapping[selectedKey]}</Content>
      </Layout>
    </Layout>
  );
}

export default Bestamp;
